// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__ziX1Q","footer":"ModalUpdate_footer__22zCw"};